import { Component, inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';
import { Organisation } from '../../models/server/Organisation';
import { SampleOrg } from '../../models/server/SampleOrg';
import { ErrorHandlerService } from '../../services/errorhandler.service';
import { LoadingService, LoadingState } from '../../services/loading.service';
import { SampleService } from '../../services/sample.service';
import { AsyncPipe } from '@angular/common';
import { DialogTitleComponent } from '../dialog-title/dialog-title.component';
import { MaterialModule } from '../../material.module';

@Component({
    selector: 'app-add-samples-dialog',
    templateUrl: './add-samples-dialog.component.html',
    styleUrls: ['./add-samples-dialog.component.scss'],
    imports: [MaterialModule, DialogTitleComponent, FormsModule, ReactiveFormsModule, AsyncPipe]
})
export class AddSamplesDialogComponent {

  form: FormGroup;
  samples: Observable<SampleOrg[]>;

  private sampleService = inject(SampleService);
  private fb = inject(FormBuilder);
  private loadingService = inject(LoadingService);
  private errorHandler = inject(ErrorHandlerService);
  private snackBar = inject(MatSnackBar);
  public organisation = inject<Organisation>(MAT_DIALOG_DATA);

  constructor() {
    this.createForm();
    this.samples = this.sampleService.getSamples();
  }

  goAhead(): void {

    let ls: LoadingState = null;
    let selectedSample = this.form.controls.sample.value as SampleOrg;

    ls = this.loadingService.add('app', `Adding Samples from ${selectedSample.title}...`);
    this.sampleService.addSamples(selectedSample.organisationId)
      .subscribe({
        next: res => {
          if (res)
            this.snackBar.open('Samples added successfully');
        },
        complete: () => {
          this.loadingService.remove(ls);
        },
        error: async err => {
          await this.errorHandler.handleErr(err);
        }
      });
  }


  private createForm(): void {
    this.form = this.fb.group({
      sample: new FormControl<SampleOrg>(null)
    });
  }
}
